import React from 'react';

const AnimatedBriefcase = ({ isOpen, className = "" }) => {
  return (
    <div className={className} style={{ perspective: '200px' }}>
      <div className="relative w-full h-full">
        {/* Back rectangle - static SVG */}
        <svg viewBox="0 0 148 132" fill="none" className="absolute inset-0 w-full h-full">
          <rect
            x="10" y="30"
            width="128" height="100"
            rx="16"
            className="fill-app-gray-400 stroke-app-gray-700"
            strokeWidth="12"
          />
        </svg>
        
        {/* Front group - animated SVG */}
        <svg 
          viewBox="0 0 148 132" 
          fill="none" 
          className="absolute inset-0 w-full h-full"
          style={{
            transformOrigin: 'bottom center',
            transition: 'transform 0.2s ease',
            transform: isOpen ? 'perspective(64px) rotateX(-60deg)' : 'translateZ(0)',
            willChange: 'transform',
            backfaceVisibility: 'hidden',
            transformStyle: 'preserve-3d',
            imageRendering: 'crisp-edges'
          }}
        >
          {/* Handle - bottom-aligned with case, extends upward */}
          <rect
            x="50" y="0"
            width="48" height="40"
            rx="16"
            fill="none"
            className="stroke-app-gray-700"
            strokeWidth="12"
          />

          {/* Front case */}
          <rect
            x="10" y="30"
            width="128" height="100"
            rx="16"
            className="fill-app-gray-200 stroke-app-gray-700"
            strokeWidth="12"
          />
          
        </svg>
      </div>
    </div>
  );
};

export default AnimatedBriefcase;